<template>
    <div class="wrapper">
        <div class="home-wrapper">
            <router-view></router-view>
        </div>
        <div class="placeholder"></div>
        <div class="bottom-nav">
            <ul class="nav-list">                
                <router-link to="/"  tags='li' class="nav-element">
                    <i class="icon icon-home"></i>
                    <p class="nav-text">Home</p>
                    <span class="additional">new</span>
                </router-link>
                <router-link to="/order"  tags='li' class="nav-element">
                    <i class="icon icon-order"></i>
                    <p class="nav-text">Orders</p>
                </router-link>   
                <router-link to="/personal"  class="nav-element" tags='li'>
                    <i class="icon icon-personal"></i>
                    <p class="nav-text">Account</p>
                </router-link>                
            </ul>
        </div>
        <Feedback></Feedback>
    </div>
</template>

<script>
import Feedback from '../components/feedback.vue'
export default {
    components:{
        Feedback
    }
}
</script>
<style lang="less" scoped>
    @import "assets/less/icon.less";
    .wrapper{
        .home-wrapper{
            width: 100%;
            // background:#fff;
        }
        .placeholder{
            height: 175px;
            width:750px;
            bottom:0            
        }
    }
    .bottom-nav{
        position:fixed;
        bottom:0;
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        padding:30px 0 0;
        z-index: 99998;
        background:#fff;
        .nav-list{            
            .nav-element{
                width: 250px;
                height: 112px;
                float:left;
                // display:flex;
                justify-content: center;
                text-decoration:none;
                position: relative;
                .nav-text{
                    text-align: center;
                    color:#A59BB3;
                    font-size: 24px;
                    &.active{
                        color:#FF9110;
                        font-size: 24px;
                    }
                }
                .additional{
                    position:absolute;
                    color:#fff;
                    padding:3px;
                    background: red;
                    font-size: 20px;
                    border-radius: 5px;
                    top:5px;
                    left:130px;
                    transform: rotate(0deg);
                }
            }
            &.router-link-exact-active{
                .nav-text{
                    color:#FF9110;
                }
            }
        }

    }
</style>